import { isEnglish } from 'helpers/locales';

export const FLASH_SALE_START = new Date('2026-10-29T22:00:00+01:00');
export const FLASH_SALE_END = new Date('2026-11-02T23:59:59.999+01:00');
export const FLASH_SALE_TRIAL_DAYS = 60;

export const isFlashSaleActive = (locale: string, now = new Date()) =>
  !isEnglish(locale) && now >= FLASH_SALE_START && now <= FLASH_SALE_END;
